"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledGenericTable = void 0;
var _proRegularSvgIcons = require("@fortawesome/pro-regular-svg-icons");
var _classnames = _interopRequireDefault(require("classnames"));
var _clsx = _interopRequireDefault(require("clsx"));
var _react = _interopRequireWildcard(require("react"));
var _APTooltip = require("../Tooltip/APTooltip");
var _button = require("../button");
var _external = require("../external");
var _StyledTable = require("./StyledTable.styles");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var StyledGenericTable = function StyledGenericTable(_ref) {
  var columns = _ref.columns,
    data = _ref.data,
    columnGroups = _ref.columnGroups,
    testId = _ref.testId,
    handleTableRowClick = _ref.handleTableRowClick,
    clickable = _ref.clickable,
    activeColumn = _ref.activeColumn,
    sortOrder = _ref.sortOrder,
    characterLength = _ref.characterLength,
    handleTableSorting = _ref.handleTableSorting,
    multiSelectable = _ref.multiSelectable,
    totalRowNumber = _ref.totalRowNumber,
    keyColumn = _ref.keyColumn,
    canOnlySelectSameTypeBaseOnColumn = _ref.canOnlySelectSameTypeBaseOnColumn,
    canOnlySelectSameTypeBaseOnFunction = _ref.canOnlySelectSameTypeBaseOnFunction,
    disabledSelection = _ref.disabledSelection,
    checkboxDisabledMessage = _ref.checkboxDisabledMessage,
    _ref$selectedIds = _ref.selectedIds,
    selectedIds = _ref$selectedIds === void 0 ? [] : _ref$selectedIds,
    setSelectedIds = _ref.setSelectedIds,
    sections = _ref.sections,
    defaultExpanded = _ref.defaultExpanded,
    multiSelectAlign = _ref.multiSelectAlign,
    _ref$showSelectAllChe = _ref.showSelectAllCheckbox,
    showSelectAllCheckbox = _ref$showSelectAllChe === void 0 ? true : _ref$showSelectAllChe,
    className = _ref.className,
    expandMap = _ref.expandMap,
    hideSelect = _ref.hideSelect,
    disabledWithOpacity = _ref.disabledWithOpacity;
  var classes = (0, _StyledTable.useStyles)();
  var isSelected = function isSelected(name) {
    return selectedIds.indexOf(name) !== -1;
  };
  var _React$useState = _react["default"].useState(),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    selectedItemsType = _React$useState2[0],
    setSelectedItemsType = _React$useState2[1];
  var _React$useState3 = _react["default"].useState(),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    firstSelectedItem = _React$useState4[0],
    setFirstSelectedItem = _React$useState4[1];
  (0, _react.useEffect)(function () {
    var item = data.find(function (record) {
      return record.id === selectedIds[0];
    });
    if (item && selectedIds.length === 1) {
      if (canOnlySelectSameTypeBaseOnColumn) {
        setSelectedItemsType(item[canOnlySelectSameTypeBaseOnColumn]);
      }
      setFirstSelectedItem(item);
    } else if (selectedIds.length === 0) {
      setSelectedItemsType(undefined);
      setFirstSelectedItem(undefined);
    }
  }, [canOnlySelectSameTypeBaseOnColumn, data, selectedIds]);
  var shouldEnableCheckBox = function shouldEnableCheckBox(record) {
    if (disabledSelection && disabledSelection(record)) {
      return false;
    }
    // Compare By column name
    if (record && canOnlySelectSameTypeBaseOnColumn && selectedItemsType && record.hasOwnProperty(canOnlySelectSameTypeBaseOnColumn)) {
      return record[canOnlySelectSameTypeBaseOnColumn] === selectedItemsType;
    }

    // Compare by function
    if (record && canOnlySelectSameTypeBaseOnFunction && firstSelectedItem) {
      return canOnlySelectSameTypeBaseOnFunction(firstSelectedItem, record);
    }
    return true;
  };
  var handleClick = function handleClick(event, name) {
    var selectedIndex = selectedIds.indexOf(name);
    var newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedIds, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedIds.slice(1));
    } else if (selectedIndex === selectedIds.length - 1) {
      newSelected = newSelected.concat(selectedIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selectedIds.slice(0, selectedIndex), selectedIds.slice(selectedIndex + 1));
    }
    if (setSelectedIds) {
      setSelectedIds(newSelected);
    }
  };
  var handleSelectAllClick = function handleSelectAllClick(event) {
    if (event.target.checked) {
      var newSelectedIds = data.map(function (n) {
        if (disabledSelection && disabledSelection(n)) {
          return undefined;
        }
        if (canOnlySelectSameTypeBaseOnColumn && selectedItemsType) {
          var matchedSelectedType = n.hasOwnProperty(canOnlySelectSameTypeBaseOnColumn) && n[canOnlySelectSameTypeBaseOnColumn] === selectedItemsType;
          return keyColumn && n.hasOwnProperty(keyColumn) && matchedSelectedType ? n[keyColumn] : undefined;
        } else {
          return keyColumn && n.hasOwnProperty(keyColumn) ? n[keyColumn] : undefined;
        }
      }).filter(function (item) {
        return !!item;
      });
      if (setSelectedIds) {
        setSelectedIds(newSelectedIds);
      }
    } else {
      if (setSelectedIds) {
        setSelectedIds([]);
      }
    }
  };
  var renderCheckboxColumn = function renderCheckboxColumn(record, isItemSelected, dataId, dataTestid) {
    return /*#__PURE__*/_react["default"].createElement(_APTooltip.APTooltip, {
      title: checkboxDisabledMessage || 'This item is not selectable.',
      disableHoverListener: shouldEnableCheckBox(record),
      arrow: true,
      placement: "left"
    }, /*#__PURE__*/_react["default"].createElement(_external.TableCell, {
      padding: "checkbox"
    }, /*#__PURE__*/_react["default"].createElement(_external.Checkbox, {
      "data-testid": dataTestid,
      color: "primary",
      checked: isItemSelected,
      inputProps: {
        'aria-labelledby': dataId
      },
      onChange: function onChange(event) {
        return handleClick(event, dataId);
      },
      onClick: function onClick(event) {
        event.stopPropagation();
      },
      disabled: !shouldEnableCheckBox(record)
    })));
  };
  var formatString = function formatString(text) {
    var output = text;
    if (typeof text === 'string' && (text === null || text === void 0 ? void 0 : text.length) > characterLength) {
      output = /*#__PURE__*/_react["default"].createElement(_APTooltip.APTooltip, {
        placement: "bottom",
        arrow: true,
        title: text
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: classes.amendmentHistoryTooltip
      }, /*#__PURE__*/_react["default"].createElement("span", null, text.substring(0, characterLength), "...")));
    }
    return output;
  };
  var renderTableBody = function renderTableBody(items, isOpen, subHeader, parent) {
    return items.map(function (record, i) {
      var dataId = keyColumn && record.hasOwnProperty(keyColumn) ? record[keyColumn] : '';
      var isItemSelected = isSelected(dataId);
      return /*#__PURE__*/_react["default"].createElement(_external.TableRow, {
        key: i,
        onClick: handleTableRowClick ? function () {
          return handleTableRowClick(record);
        } : function () {},
        className: clickable ? (0, _classnames["default"])(classes.clickable, classes.link) : classes.link,
        selected: isItemSelected,
        style: {
          visibility: isOpen ? 'visible' : 'collapse',
          opacity: !shouldEnableCheckBox(record) && disabledWithOpacity ? 0.3 : 1
        }
      }, multiSelectable && multiSelectAlign !== 'end' && renderCheckboxColumn(record, isItemSelected, dataId, "checkbox-".concat(parent, "-").concat(subHeader, "-").concat(i)), columns.map(function (column, j) {
        var _record$column$access;
        return /*#__PURE__*/_react["default"].createElement(_external.TableCell, {
          className: column.accessor === 'buttons' ? classes.buttons : classes.text,
          key: j,
          align: column.align,
          style: {
            width: column.width
          }
        }, ((_record$column$access = record[column.accessor]) === null || _record$column$access === void 0 ? void 0 : _record$column$access.length) < characterLength || !column.cutString ? record[column.accessor] : /*#__PURE__*/_react["default"].createElement("p", {
          className: classes.amendmentHistoryTooltip
        }, formatString(record[column.accessor])));
      }), multiSelectable && multiSelectAlign === 'end' && renderCheckboxColumn(record, isItemSelected, dataId, "checkbox-".concat(parent, "-").concat(subHeader, "-").concat(i)));
    });
  };
  var TableSection = function TableSection(_ref2) {
    var _section$sections;
    var section = _ref2.section,
      _ref2$expanded = _ref2.expanded,
      expanded = _ref2$expanded === void 0 ? true : _ref2$expanded,
      parent = _ref2.parent,
      subHeader = _ref2.subHeader;
    var initialExpanded = section !== null && section !== void 0 && section.key && (expandMap === null || expandMap === void 0 ? void 0 : expandMap.get(section.key)) !== undefined ? expandMap.get(section.key) : defaultExpanded;
    var _useState = (0, _react.useState)(initialExpanded),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];
    (0, _react.useEffect)(function () {
      if (expandMap && section !== null && section !== void 0 && section.key) {
        expandMap.set(section.key, open);
      }
    }, [section === null || section === void 0 ? void 0 : section.key, open]);
    var subSections = (_section$sections = section.sections) === null || _section$sections === void 0 ? void 0 : _section$sections.map(function (subSection, r) {
      return /*#__PURE__*/_react["default"].createElement(TableSection, {
        section: subSection,
        expanded: open,
        parent: parent,
        subHeader: r
      });
    });
    var tableBody = renderTableBody(section.items, open, subHeader, parent);
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_external.TableBody, {
      style: {
        visibility: expanded ? 'visible' : 'collapse'
      }
    }, /*#__PURE__*/_react["default"].createElement(_external.TableRow, null, /*#__PURE__*/_react["default"].createElement(_external.TableCell, {
      colSpan: multiSelectable ? columns.length + 1 : columns.length,
      className: classes.sectionHeader
    }, /*#__PURE__*/_react["default"].createElement(_external.Box, {
      display: "flex",
      justifyContent: "space-between"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": subHeader !== undefined ? "row-".concat(parent, "-").concat(subHeader) : "row-".concat(parent)
    }, section.title), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_button.IconButton, {
      onClick: function onClick() {
        setOpen(!open);
      },
      icon: open ? _proRegularSvgIcons.faChevronUp : _proRegularSvgIcons.faChevronDown,
      style: {
        padding: '6px',
        color: '#949494',
        fontSize: '24px'
      },
      size: "medium"
    }))))), tableBody, /*#__PURE__*/_react["default"].createElement(_external.TableRow, {
      style: {
        visibility: section.footer && open ? 'visible' : 'collapse'
      }
    }, /*#__PURE__*/_react["default"].createElement(_external.TableCell, {
      colSpan: multiSelectable ? columns.length + 1 : columns.length
    }, section.footer))), open ? subSections : null);
  };
  var renderCheckboxHeader = function renderCheckboxHeader() {
    return /*#__PURE__*/_react["default"].createElement(_external.TableCell, {
      padding: "checkbox"
    }, !showSelectAllCheckbox && !hideSelect ? 'Select' : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null), showSelectAllCheckbox && !canOnlySelectSameTypeBaseOnColumn && !canOnlySelectSameTypeBaseOnFunction && /*#__PURE__*/_react["default"].createElement(_external.Checkbox, {
      color: "primary",
      checked: Boolean(totalRowNumber && selectedIds.length === totalRowNumber),
      indeterminate: Boolean(totalRowNumber && selectedIds.length >= 1 && selectedIds.length < totalRowNumber),
      onChange: handleSelectAllClick,
      inputProps: {
        'aria-label': 'select all desserts'
      }
    }));
  };
  var tableHead = /*#__PURE__*/_react["default"].createElement(_external.TableHead, null, columnGroups && /*#__PURE__*/_react["default"].createElement(_external.TableRow, null, multiSelectable && multiSelectAlign !== 'end' && /*#__PURE__*/_react["default"].createElement(_external.TableCell, null), columnGroups.map(function (columnGroup) {
    return /*#__PURE__*/_react["default"].createElement(_external.TableCell, {
      colSpan: columnGroup.span,
      align: columnGroup.align,
      key: columnGroup.header.toString()
    }, columnGroup.header);
  }), multiSelectable && multiSelectAlign === 'end' && /*#__PURE__*/_react["default"].createElement(_external.TableCell, null)), /*#__PURE__*/_react["default"].createElement(_external.TableRow, null, multiSelectable && multiSelectAlign !== 'end' && renderCheckboxHeader(), columns.map(function (column, i) {
    return /*#__PURE__*/_react["default"].createElement(_external.TableCell, {
      key: i,
      align: column.align,
      style: {
        width: column.width
      }
    }, column.sortable ? /*#__PURE__*/_react["default"].createElement(_external.TableSortLabel, {
      active: activeColumn === column.accessor,
      direction: sortOrder,
      onClick: handleTableSorting ? function () {
        return handleTableSorting(column.accessor);
      } : undefined
    }, column.header) : column.header);
  }), multiSelectable && multiSelectAlign === 'end' && renderCheckboxHeader()));
  var renderSections = function renderSections(s) {
    if (!s) {
      return [];
    }
    return s === null || s === void 0 ? void 0 : s.map(function (_s, i) {
      return /*#__PURE__*/_react["default"].createElement(TableSection, {
        section: _s,
        key: _s.key || '',
        parent: i
      });
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_external.Table, {
    "data-testid": testId,
    className: (0, _clsx["default"])(classes.table, className)
  }, tableHead, data && data.length > 0 ? /*#__PURE__*/_react["default"].createElement(_external.TableBody, null, renderTableBody(data, true)) : null, renderSections(sections));
};
exports.StyledGenericTable = StyledGenericTable;
var isRequiredForMultiSelectable = function isRequiredForMultiSelectable(props, propName, componentName) {
  if (props.multiSelectable) {
    if (!props.totalRowNumber || !props.keyColumn || !props.selectedIds || !props.setSelectedIds) {
      return new Error("Invalid props passed to ".concat(componentName, ". Expected a valid totalRowNumber and keyColumn when multiSelectable is enabled."));
    }
  }
  return null;
};
StyledGenericTable.propTypes = {
  totalRowNumber: isRequiredForMultiSelectable,
  keyColumn: isRequiredForMultiSelectable,
  selectedIds: isRequiredForMultiSelectable,
  setSelectedIds: isRequiredForMultiSelectable
};